themeBase.requestIdleCallback(() => {
  const footbarPosition = document.querySelector('product-footbar')?.dataset.position;
if (footbarPosition !== 'bottom') {
  themeSettings.disableStickyHeader = () => themeBase.isDesktop;
}
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.executeWhenScriptLoaded(['cart.js', 'product-form.js'], () => {
      if (!customElements.get('product-footbar')) {
        class ProductFootbar extends HTMLElement {
          constructor() {
            super();

            this.product = document.querySelector('.product');
            this.productButtonAddToCart = this.product.querySelector('[name="add"]');
            this.variants = this.querySelector('[name="id"]');

            this.variants.addEventListener('change', this.onChange.bind(this));
            window.addEventListener('MutationObserverLoaded', this.checkOverlay.bind(this));
            window.addEventListener('throttle30fpsMove', this.checkOverlay.bind(this));
          }

          onChange(event) {
            const options = event.target.querySelectorAll('option');
            const productVariantSwitcher = document.querySelector(`variant-radios[data-section="${this.dataset.sectionId}"]`) || document.querySelector(`variant-selects[data-section="${this.dataset.sectionId}"]`);

            options.forEach(element => {
              if (element.selected) {
                const variantData = JSON.parse(this.product.querySelector('[type="application/json"]').textContent);
                const currentVariant = variantData.filter((variant) => {
                  return variant.id == element.value;
                })[0];

                productVariantSwitcher.changeOptions(currentVariant.options);
                productVariantSwitcher.onVariantChange({
                  isFootbar: true
                });
                return false;
              }
            });
          }

          checkOverlay() {
            const productButtonAddToCartBound = themeBounds.get(this.productButtonAddToCart);
            const isVisible = productButtonAddToCartBound.bottom < 0 || productButtonAddToCartBound.top > window.innerHeight;

            this.classList[isVisible ? 'add' : 'remove']('product-footbar__wrapper--visible');

            if (isVisible) {
              document.documentElement.style.setProperty('--product-footbar-height', `${themeBounds.get(this).height.toFixed(1) / 10}rem`);
            } else {
              document.documentElement.style.setProperty('--product-footbar-height', '');
            }
          }
        }

        customElements.define('product-footbar', ProductFootbar);
      }
    });
  });
});